import React from "react";
import "./style.css";
import {QuestionnaireSelect} from "../../../../components/QuestionnaireSelect";

export const WaterIntake = (props) => {
  const data = {
    title: "What is your daily water intake?",
    list: [{
      content: "I only have coffee or tea",
    },{
      content: "About 2 glasses (16 oz)",
    },{
      content: "2 to 6 glasses (16-48 oz)",
    },{
      content: "More than 6 glasses",
    }]
  };

  return (
    <div className="gallery-page">
      <QuestionnaireSelect list={data} {...props} />
    </div>
  );
};
